import { gql, useMutation } from "@apollo/client";

const REQUEST_WITHDRAWAL = gql`
  mutation requestWithdrawal($purchaseKey: String) {
    requestWithdrawal(purchaseKey: $purchaseKey) {
      purchaseKey
      canRequest
      request {
        id
        status
        requestedAtUtc
      }
    }
  }
`;

export function useRequestWithdrawal() {
  const [mutate, { loading }] = useMutation(REQUEST_WITHDRAWAL);

  const requestWithdrawal = async (
    purchaseKey: string | null | undefined,
  ): Promise<void> => {
    await mutate({ variables: { purchaseKey: purchaseKey ?? null } });
  };

  return { requestWithdrawal, loading };
}
